export const convertToReadableStream = async (
  body: ReadableStream<Uint8Array>,
  handleValueUpdate: (val: string) => void,
  onDone: () => void
) => {
  const reader = body.getReader()
  const decoder = new TextDecoder()

  while (true) {
    const { value, done } = await reader.read()

    if (done) {
      onDone()
      break
    }

    const chunk = decoder.decode(value)
    handleValueUpdate(chunk)
  }

  reader.releaseLock()
}
